export default "__VITE_ASSET__DNb7k4dW__"